/**
 * Global footer — rendered on all pages (public + protected) via App.tsx.
 * Contains privacy policy, cookie policy, and cookie-settings re-open links
 * (UK GDPR Art. 7(3) — consent withdrawable as easily as given) + the
 * Innovate Design copyright. British English project.
 */
import { Link } from 'react-router-dom';
import { reopenConsentBanner } from './ConsentBanner';
import './Footer.css';

export function Footer() {
  return (
    <footer className="itk-footer">
      <div className="itk-footer__inner">
        <nav className="itk-footer__links" aria-label="Legal">
          <Link to="/privacy-policy" className="itk-footer__link">
            Privacy policy
          </Link>
          <Link to="/cookie-policy" className="itk-footer__link">
            Cookie policy
          </Link>
          <button type="button" className="itk-footer__link itk-footer__link--btn" onClick={reopenConsentBanner}>
            Cookie settings
          </button>
        </nav>
        <p className="itk-footer__copy">
          &copy; {new Date().getFullYear()} Innovate Design Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
}